import Sounds from './Sounds';

export default {
  install (Vue) {
    Vue.directive('sound', {
      bind (el, { value }) {
        function handler () { value in Sounds && Sounds[value](); }
        el.addEventListener('click', handler);
        el._sound_handler = handler;
      },
      unbind (el) {
        if (el._sound_handler) {
          el.removeEventListener('click', el._sound_handler);
        }
      },
    });
  },
};
